AppTabs.createTab( {
name: 'preserved-by',
icon: 'list-alt',
text: 'Preserved By',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-preserved-by',

		readTableName: 	'tblPreservedBy',
		editTableName: 	'tblPreservedBy',
		primaryKey: 	'PreservedByID',

		canSort:			false,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'preservedByOptions' );
		},

		fields: [
			{
				label: 		'',
				columnName: 'PreservedBy',
				isEditable: true,
				order: 		'asc',
			},
		],

	} );
}

} );
